import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from './Layout/Layout';
import Dashboard from './Pages/Dashboard';
// import Logout from './Pages/Logout';
import Login from './Pages/Auth/Login';
import State from './Pages/State/State';
import AddState from './Pages/State/Addstate';


//SubAdminManagment

import AddAdmin from './Pages/SubAdminManagment/AddAdmin';
import AdminList from './Pages/SubAdminManagment/AdminList';
import WaadDetails from './Pages/SubAdminManagment/WaadDetails';
import AdminPermissionsPage from "./Pages/SubAdminManagment/AdminPermissions";

import AdminUpdate from './Pages/SubAdminManagment/AdminUpdate';
import AdminView from './Pages/SubAdminManagment/AdminView';
import City from './Pages/City/City';
import Amenities from './Pages/Amenities/AddAmenities';
import AllAmenities from './Pages/Amenities/Allamenities';
// import AllProperty from './Pages/PropertyManagement/AllProperty';
// import PropertyOwner from './Pages/PropertyManagement/PropertyOwner';
// import PropertyRequest from './Pages/PropertyManagement/PropertyRequest';
import AddBlog from './Pages/Blog/AddBlog';
import Allblog from './Pages/Blog/Allblog';
import AddCity from './Pages/City/AddCity';

//District

import AddDistrict from './Pages/District/AddDistrict';
import District from './Pages/District/District';

// import AllMember from './Pages/FamilyManagment/AllMember';
import AllProductList from './Pages/ProductManagment/ProductList';
import AddProduct from './Pages/ProductManagment/createProduct';
import AddProductImages from './Pages/ProductManagment/ProductImageManagment/AddProductImages';
import ViewProductImages from './Pages/ProductManagment/ProductImageManagment/ViewProductImages';
import UpdateProductImages from './Pages/ProductManagment/ProductImageManagment/EditProductImages';
import EditProduct from './Pages/ProductManagment/updateProduct';
import ViewProduct from './Pages/ProductManagment/viewProduct';
import SubCategoriesList from './Pages/SubCategoryManagment/SubCategorieslist';
import Categorieslist from './Pages/CategoryManagment/Categorieslist';
import createCategory from './Pages/CategoryManagment/createCategory';
import AddSubCategory from './Pages/SubCategoryManagment/createSubCategory';
// import AddTestimonial from './Pages/FamilyManagment/AddTestimonials';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProtectedRoute from './routes/ProtectedRoute';
import GlobalModal from './common/GlobalModal';
import AddFAQ from './Pages/FAQ/AddFaq';
import FAQList from './Pages/FAQ/FaqList';
import LocationList from './Pages/Location/Location';
import AddLocation from './Pages/Location/AddLocation';
import SettingsForm from './Pages/SettingsForm';

import AddGotra from './Pages/Gotra/Addgotra'
import GotraList from './Pages/Gotra/Gotra'

import NanihalGotraList from './Pages/NanihalGotra/NanihalGotra'
import AddNanihalgotra from './Pages/NanihalGotra/AddNanihalgotra'

import AddKuldevi from './Pages/Kuldevi/AddKuldevi'
import KuldeviList from './Pages/Kuldevi/Kuldevi'

import AddEducation from './Pages/Educations/AddEducation'
import EducationList from './Pages/Educations/Education'

import AddEvent from './Pages/EventManagement/AddEvents';
import EventList from './Pages/EventManagement/Events';

import AddOccupation from './Pages/Occupation/AddOccupation'
import OccupationList from './Pages/Occupation/Occupation'

import Bannerlist from './Pages/BannerManagment/Bannerlist'
import CreateBanner from './Pages/BannerManagment/createBanner'

import PendingMembers from './Pages/FamilyManagment/PendingList';
import SuccessMembers from './Pages/FamilyManagment/SuccessList';
import RejectedMembers from './Pages/FamilyManagment/RejectedList';
import PariwarView from './Pages/FamilyManagment/MemberView';
import EditUser from './Pages/FamilyManagment/EditUser';


import PendingList from './Pages/MemberManagment/PendingList';
import SuccessList from './Pages/MemberManagment/SuccessList';
import RejectedList from './Pages/MemberManagment/RejectedList';
import PariwarList from './Pages/MemberManagment/PariwarView';

import AddNews from './Pages/NewsManagement/AddNews';
import News from './Pages/NewsManagement/News';
import Helpdesk from './Pages/Helpdesk/Helpdesk';
import Employment from './Pages/Employment/Employment';
import CreateEmployment from './Pages/Employment/CreateEmployment';
import EditEmployment from './Pages/Employment/EditEmployment';


import Education from './Pages/Scholarships/Education';
import StudentRegistrations from './Pages/Scholarships/StudentRegistrations';
import CreateScholarship from './Pages/Scholarships/CreateScholarship';
import EditScholarship from './Pages/Scholarships/EditScholarship';

import Buildings from './Pages/Building/Buildings';
import Bookings from './Pages/Building/Bookings';
import CreateBuilding from './Pages/Building/CreateBuilding';
import EditBuilding from './Pages/Building/EditBuilding';
import ViewBuilding from './Pages/Building/ViewBuilding';

// Waad Pages
import Waad from './Pages/waad/Waad';
import AddWaad from './Pages/waad/AddWaad';

import Selections from "./Pages/Selections/Selections";
import AddSelection from "./Pages/Selections/AddSelection";
import EditSelection from "./Pages/Selections/EditSelection";

// Gaon Pages
import Gaon from './Pages/gaon/Gaon';
import AddGaon from './Pages/gaon/AddGaon';


const App = () => {
  return (
    <Router>
      <Routes>


        <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
        <Route path="/add-amenities" element={<ProtectedRoute><Layout><Amenities /></Layout></ProtectedRoute>} />
        <Route path="/all-amenities" element={<ProtectedRoute><Layout><AllAmenities /></Layout></ProtectedRoute>} />
        <Route path="/states" element={<ProtectedRoute><Layout><State /></Layout></ProtectedRoute>} />
        <Route path="/add-state" element={<ProtectedRoute><Layout><AddState /></Layout></ProtectedRoute>} />
        <Route path="/city" element={<ProtectedRoute><Layout><City /></Layout></ProtectedRoute>} />
        <Route path="/add-city" element={<ProtectedRoute><Layout><AddCity /></Layout></ProtectedRoute>} />

        <Route path="/add-district" element={<ProtectedRoute><Layout><AddDistrict /></Layout></ProtectedRoute>} />
        <Route path="/district" element={<ProtectedRoute><Layout><District /></Layout></ProtectedRoute>} />

        <Route path="/all-blog" element={<ProtectedRoute><Layout><Allblog /></Layout></ProtectedRoute>} />
        <Route path="/add-blog" element={<ProtectedRoute><Layout><AddBlog /></Layout></ProtectedRoute>} />
        {/* <Route path="/all-members" element={<ProtectedRoute><Layout><AllMember /></Layout></ProtectedRoute>} /> */}
        {/* <Route path="/add-testimonial" element={<ProtectedRoute><Layout><AddTestimonial /></Layout></ProtectedRoute>} /> */}
        <Route path="/add-category" element={<ProtectedRoute><Layout><createCategory /></Layout></ProtectedRoute>} />
        <Route path="/add-sub-category" element={<ProtectedRoute><Layout><AddSubCategory /></Layout></ProtectedRoute>} />
        <Route path="/categories-list" element={<ProtectedRoute><Layout><Categorieslist /></Layout></ProtectedRoute>} />
        <Route path="/sub-categories-list" element={<ProtectedRoute><Layout><SubCategoriesList /></Layout></ProtectedRoute>} />
        <Route path="/product-list" element={<ProtectedRoute><Layout><AllProductList /></Layout></ProtectedRoute>} />
        <Route path="/create-product" element={<ProtectedRoute><Layout><AddProduct /></Layout></ProtectedRoute>} />
        <Route path="/add-product-images/:id" element={<ProtectedRoute><Layout><AddProductImages /></Layout></ProtectedRoute>} />
        <Route path="/update-product-images/:id" element={<ProtectedRoute><Layout><UpdateProductImages /></Layout></ProtectedRoute>} />
        <Route path="/view-product-images/:id" element={<ProtectedRoute><Layout><ViewProductImages /></Layout></ProtectedRoute>} />
        <Route path="/view-product/:id" element={<ProtectedRoute><Layout><ViewProduct /></Layout></ProtectedRoute>} />
        <Route path="/update-product/:id" element={<ProtectedRoute><Layout><EditProduct /></Layout></ProtectedRoute>} />
        <Route path="/create-location" element={<ProtectedRoute><Layout><AddLocation /></Layout></ProtectedRoute>} />
        <Route path="/location-list" element={<ProtectedRoute><Layout><LocationList /></Layout></ProtectedRoute>} />
        <Route path="/faq-list" element={<ProtectedRoute><Layout><FAQList /></Layout></ProtectedRoute>} />
        <Route path="/add-faq" element={<ProtectedRoute><Layout><AddFAQ /></Layout></ProtectedRoute>} />
        <Route path="/web-setting" element={<ProtectedRoute><Layout><SettingsForm /></Layout></ProtectedRoute>} />

        //SubAdminManagment

        <Route path="/add-admin" element={<ProtectedRoute><Layout><AddAdmin /></Layout></ProtectedRoute>} />
        <Route path="/admin-list" element={<ProtectedRoute><Layout><AdminList /></Layout></ProtectedRoute>} />
        <Route path="/waad-details/:waadId" element={
          <ProtectedRoute>
            <Layout>
              <WaadDetails />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/admin-permissions/:adminId" element={<ProtectedRoute><Layout><AdminPermissionsPage /></Layout></ProtectedRoute>} />
        <Route path="/admin-view" element={<ProtectedRoute><Layout><AdminView /></Layout></ProtectedRoute>} />
        <Route path="/admin-update" element={<ProtectedRoute><Layout><AdminUpdate /></Layout></ProtectedRoute>} />


        <Route path="/gotra-list" element={<ProtectedRoute><Layout><GotraList /></Layout></ProtectedRoute>} />
        <Route path="/add-gotra" element={<ProtectedRoute><Layout><AddGotra /></Layout></ProtectedRoute>} />

        <Route path="/nanihal-gotra" element={<ProtectedRoute><Layout><NanihalGotraList /></Layout></ProtectedRoute>} />
        <Route path="/add-nanihal-gotra" element={<ProtectedRoute><Layout><AddNanihalgotra /></Layout></ProtectedRoute>} />

        <Route path="/kuldevi" element={<ProtectedRoute><Layout><KuldeviList /></Layout></ProtectedRoute>} />
        <Route path="/add-kuldevi" element={<ProtectedRoute><Layout><AddKuldevi /></Layout></ProtectedRoute>} />

        <Route path="/education" element={<ProtectedRoute><Layout><EducationList /></Layout></ProtectedRoute>} />
        <Route path="/add-education" element={<ProtectedRoute><Layout><AddEducation /></Layout></ProtectedRoute>} />

        <Route path="/events" element={<ProtectedRoute><Layout><EventList /></Layout></ProtectedRoute>} />
        <Route path="/add-event" element={<ProtectedRoute><Layout><AddEvent /></Layout></ProtectedRoute>} />

        <Route path="/occupation" element={<ProtectedRoute><Layout><OccupationList /></Layout></ProtectedRoute>} />
        <Route path="/add-occupation" element={<ProtectedRoute><Layout><AddOccupation /></Layout></ProtectedRoute>} />

        <Route path="/banner-list" element={<ProtectedRoute><Layout><Bannerlist /></Layout></ProtectedRoute>} />
        <Route path="/add-banner" element={<ProtectedRoute><Layout><CreateBanner /></Layout></ProtectedRoute>} />


        <Route path="/news" element={<ProtectedRoute><Layout><News /></Layout></ProtectedRoute>} />
        <Route path="/add-news" element={<ProtectedRoute><Layout><AddNews /></Layout></ProtectedRoute>} />

        <Route path="/helpdesk" element={<ProtectedRoute><Layout><Helpdesk /></Layout></ProtectedRoute>} />
        <Route path="/employment" element={<ProtectedRoute><Layout><Employment /></Layout></ProtectedRoute>} />
        <Route path="/create-employment" element={<ProtectedRoute><Layout><CreateEmployment /></Layout></ProtectedRoute>} />
        <Route path="/edit-employment/:id" element={<ProtectedRoute><Layout><EditEmployment /></Layout></ProtectedRoute>} />
        <Route path="/admin/education" element={<ProtectedRoute><Layout><Education /></Layout></ProtectedRoute>} />
        <Route path="/admin/student-registrations" element={<ProtectedRoute><Layout><StudentRegistrations /></Layout></ProtectedRoute>} />
        <Route path="/admin/create-scholarship" element={<ProtectedRoute><Layout><CreateScholarship /></Layout></ProtectedRoute>} />
        <Route path="/admin/edit-scholarship/:id" element={<ProtectedRoute><Layout><EditScholarship /></Layout></ProtectedRoute>} />

        <Route path="/admin/buildings" element={<ProtectedRoute><Layout><Buildings /></Layout></ProtectedRoute>} />
        <Route path="/admin/bookings" element={<ProtectedRoute><Layout><Bookings /></Layout></ProtectedRoute>} />
        <Route path="/admin/create-building" element={<ProtectedRoute><Layout><CreateBuilding /></Layout></ProtectedRoute>} />
        <Route path="/admin/edit-building/:id" element={<ProtectedRoute><Layout><EditBuilding /></Layout></ProtectedRoute>} />
        <Route path="/admin/view-building/:id" element={<ProtectedRoute><Layout><ViewBuilding /></Layout></ProtectedRoute>} />
        <Route path="/waad" element={<ProtectedRoute><Layout><Waad /></Layout></ProtectedRoute>} />
        <Route path="/add-waad" element={<ProtectedRoute><Layout><AddWaad /></Layout></ProtectedRoute>} />
        <Route path="/gaon" element={<ProtectedRoute><Layout><Gaon /></Layout></ProtectedRoute>} />
        <Route path="/add-gaon" element={<ProtectedRoute><Layout><AddGaon /></Layout></ProtectedRoute>} />
        <Route path="/selections" element={<ProtectedRoute><Layout><Selections /></Layout></ProtectedRoute>} />
        <Route path="/add-selection" element={<ProtectedRoute><Layout><AddSelection /></Layout></ProtectedRoute>} />
        <Route path="/edit-selection/:id" element={<ProtectedRoute><Layout><EditSelection /></Layout></ProtectedRoute>} />




        <Route
          path="/pariwar-pending"
          element={
            <ProtectedRoute>
              <Layout>
                <PendingMembers />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/pariwar-success"
          element={
            <ProtectedRoute>
              <Layout>
                <SuccessMembers />
              </Layout>
            </ProtectedRoute>
          }
        />
         <Route
          path="/edit-user/:role/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <EditUser />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/pariwar-rejected"
          element={
            <ProtectedRoute>
              <Layout>
                <RejectedMembers />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/pariwar-view/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <PariwarView />
              </Layout>
            </ProtectedRoute>
          }
        />


        <Route
          path="/sadasya-pending"
          element={
            <ProtectedRoute>
              <Layout>
                <PendingList />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/sadasya-success"
          element={
            <ProtectedRoute>
              <Layout>
                <SuccessList />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/sadasya-rejected"
          element={
            <ProtectedRoute>
              <Layout>
                <RejectedList />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/sadasya-view/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <PariwarList />
              </Layout>
            </ProtectedRoute>
          }
        />





    

        <Route path="/Login" element={<Login />} />
      </Routes>
      <GlobalModal />
    </Router>
  );
};

export default App;